import { createAction, props } from '@ngrx/store';

import { StyleHeaderEnum } from '@shared/header/models/header.models';

export const HeaderActionTypes = {
    HEADER_READY: '[Header] HEADER_READY',

    SET_HEADER_THEME: '[Header] SET_HEADER_THEME',

    SET_HEADER_STYLES: '[Header] SET_HEADER_STYLES',
    SET_HEADER_STYLES_ON_SCROLL: '[Header] SET_HEADER_STYLES_ON_SCROLL',

    SET_TOP_NOTIFICATION_HEIGHT: '[Header] SET_TOP_NOTIFICATION_HEIGHT',

    OPEN_SEARCH_FROM_HEADER: '[Header] OPEN_SEARCH_FROM_HEADER',
};

export const HeaderReady = createAction(HeaderActionTypes.HEADER_READY);
export const SetHeaderTheme = createAction(
    HeaderActionTypes.SET_HEADER_THEME,
    props<{ theme: StyleHeaderEnum }>()
);

export const OpenSearchFromHeader = createAction(HeaderActionTypes.OPEN_SEARCH_FROM_HEADER, props<{ from?: string }>());
